<template>
  <!-- Add Leave Modal -->
  <div id="add_leave" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Leave Type</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
			ref="addleaveclose"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
		
          <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Code <span class="text-danger">*</span></label
              >
              <Field
                name="code"
                type="text"
                class="form-control"
                v-model="form.code"
                :class="{
                  'is-invalid': errors?.code ? errors.code[0] : '',
                }"
              />
              <div class="invalid-feedback">
                {{ errors.code }}
              </div>
              <div class="codeshow text-danger" id="code"></div>
            </div>
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Name <span class="text-danger">*</span></label
              >
              <Field
                name="name"
                type="text"
                class="form-control"
                v-model="form.name"
                :class="{
                  'is-invalid': errors?.name ? errors.name[0] : '',
                }"
              />
              <div class="invalid-feedback">
                {{ errors.name }}
              </div>
              <div class="nameshow text-danger" id="name"></div>
            </div>
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Entitlement Days <span class="text-danger">*</span></label
              >
              <Field
                name="entitlement_days"
                type="text"
                class="form-control"
                v-model="form.entitlement_days"
                :class="{
                  'is-invalid': errors?.entitlement_days ? errors.entitlement_days[0] : '',
                }"
              />
              <div class="invalid-feedback">
                {{ errors.entitlement_days }}
              </div>
              <div class="entitlement_daysshow text-danger" id="entitlement_days"></div>
            </div>
			
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Accural Rule <span class="text-danger">*</span></label
              >
			  <Field
                    name="accrual_rule"
                    as="select"
                    class="form-control"
					v-model="form.accrual_rule"
					:class="{ 'is-invalid': errors.accrual_rule }"
                  >
				  <option value="">Select Accural Rule</option>
				  <option value="monthly">Monthly</option>
				  <option value="fixed">Fixed</option>
				  <option value="deduct_from_SL">Deduct From SL</option>
				  
				  <div class="invalid-feedback">{{ errors.accrual_rule }}</div>
                  <div class="accrual_ruleshow text-danger" id="accrual_rule"></div>
			  </Field>
			</div>
			
			<!--
			<div class="input-block mb-3 d-flex align-items-center">
			  <label class="col-form-label mb-0 me-3">
				Carry Over <span class="text-danger">*</span>
			  </label>

			  <a-switch
				v-model="form.carry_over_allowed"
				:checked-children="'Yes'"
				:un-checked-children="'No'"
				:checked="form.carry_over_allowed == 1"
				@change="(checked) => form.carry_over_allowed = checked ? 1 : 0"
			  />

			  <div class="invalid-feedback d-block">
				{{ errors.carry_over_allowed }}
			  </div>
			</div>
			-->
			
			<div class="input-block mb-3 d-flex align-items-center">
			  <label class="col-form-label mb-0 me-3">
				Carry Over <span class="text-danger">*</span>
			  </label>

			  <a-switch
				v-model="form.carry_over_allowed"
				:checked-children="'Yes'"
				:un-checked-children="'No'"
				:checked="form.carry_over_allowed == 1"
				@change="(checked) => form.carry_over_allowed = checked ? 1 : 0"
			  />
			</div>

			<div class="invalid-feedback d-block">
			  {{ errors.carry_over_allowed }}
			</div>
			
			
			<div class="input-block mb-3 d-flex align-items-center">
			  <label class="col-form-label mb-0 me-3">
				Encashable
			  </label>

			  <a-switch
				v-model="form.encashable"
				:checked-children="'Yes'"
				:un-checked-children="'No'"
				:checked="form.encashable == 1"
				@change="(checked) => form.encashable = checked ? 1 : 0"
			  />
			</div>

			<div class="invalid-feedback d-block">
			  {{ errors.encashable }}
			</div>



			
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Gender <span class="text-danger">*</span></label
              >
			  <Field
                    name="gender_restriction"
                    as="select"
                    class="form-control"
					v-model="form.gender_restriction"
					:class="{ 'is-invalid': errors.gender_restriction }"
                  >
				  <option value="">Gender</option>
				  <option value="Any">Any</option>
				  <option value="Male">Male</option>
				  <option value="Female">Female</option>
				  
				  <div class="invalid-feedback">{{ errors.gender_restriction }}</div>
                  <div class="gender_restrictionshow text-danger" id="gender_restriction"></div>
			  </Field>
			</div>
			
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Law Reference</label
              >
              <Field
                name="law_reference"
                type="text"
                class="form-control"
                v-model="form.law_reference"
                :class="{
                  'is-invalid': errors?.law_reference ? errors.law_reference[0] : '',
                }"
              />
              <div class="invalid-feedback">
                {{ errors.law_reference }}
              </div>
              <div class="law_referenceshow text-danger" id="law_reference"></div>
            </div>

			<div class="input-block mb-3">
              <label class="col-form-label"
                >Max Consecutive Days </label
              >
              <Field
                name="max_consecutive_days"
                type="text"
                class="form-control"
                v-model="form.max_consecutive_days"
                :class="{
                  'is-invalid': errors?.max_consecutive_days ? errors.max_consecutive_days[0] : '',
                }"
              />
              <div class="invalid-feedback">
                {{ errors.max_consecutive_days }}
              </div>
              <div class="max_consecutive_daysshow text-danger" id="max_consecutive_days"></div>
            </div>
		  
			
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Status <span class="text-danger">*</span></label
              >
			  <Field
                    name="active"
                    as="select"
                    class="form-control"
					v-model="form.active"
					:class="{ 'is-invalid': errors.active }"
                  >
				  <option value="">Select Status</option>
				  <option value="1">Active</option>
				  <option value="0">Inactive</option>
				  <div class="invalid-feedback">{{ errors.active }}</div>
                  <div class="statusshow text-danger" id="active"></div>
			  </Field>
			</div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Submit</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Leave Modal -->

  <!-- Edit Leave Modal -->
  <div id="edit_leave" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Leave Type</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
			ref="editleaveclose"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onUpdate" :validation-schema="editschema" v-slot="{ errors }">
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Code <span class="text-danger">*</span></label
              >
              <Field
                name="code"
                type="text"
                class="form-control"
                v-model="editform.code"
                :class="{
                  'is-invalid': errors?.code ? errors.code[0] : '',
                }"
              />
              <div class="invalid-feedback">
                {{ errors.code }}
              </div>
              <div class="codeshow text-danger" id="code"></div>
            </div>
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Name <span class="text-danger">*</span></label
              >
              <Field
                name="name"
                type="text"
                class="form-control"
                v-model="editform.name"
                :class="{
                  'is-invalid': errors?.name ? errors.name[0] : '',
                }"
              />
              <div class="invalid-feedback">
                {{ errors.name }}
              </div>
              <div class="nameshow text-danger" id="name"></div>
            </div>
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Entitlement Days <span class="text-danger">*</span></label
              >
              <Field
                name="entitlement_days"
                type="text"
                class="form-control"
                v-model="editform.entitlement_days"
                :class="{
                  'is-invalid': errors?.entitlement_days ? errors.entitlement_days[0] : '',
                }"
              />
              <div class="invalid-feedback">
                {{ errors.entitlement_days }}
              </div>
              <div class="entitlement_daysshow text-danger" id="entitlement_days"></div>
            </div>
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Accural Rule <span class="text-danger">*</span></label
              >
			  <Field
                    name="accrual_rule"
                    as="select"
                    class="form-control"
					v-model="editform.accrual_rule"
					:class="{ 'is-invalid': errors.accrual_rule }"
                  >
				  <option value="">Select Accural Rule</option>
				  <option value="monthly">Monthly</option>
				  <option value="fixed">Fixed</option>
				  <option value="deduct_from_SL">Deduct From SL</option>
				  
				  <div class="invalid-feedback">{{ errors.accrual_rule }}</div>
                  <div class="accrual_ruleshow text-danger" id="accrual_rule"></div>
			  </Field>
			</div>
			
			<div class="input-block mb-3">
			  <label class="col-form-label">
				Carry Over <span class="text-danger">*</span>
			  </label>

			  <a-switch
				v-model="editform.carry_over_allowed"
				:checked-children="'Yes'"
				:un-checked-children="'No'"
				:checked="editform.carry_over_allowed == 1"
				@change="(checked) => editform.carry_over_allowed = checked ? 1 : 0"
			  />

			  <div class="invalid-feedback d-block">
				{{ errors.carry_over_allowed }}
			  </div>
			</div>
			
			<div class="input-block mb-3">
			  <label class="col-form-label">
				Encashable <span class="text-danger">*</span>
			  </label>

			  <a-switch
				v-model="editform.encashable"
				:checked-children="'Yes'"
				:un-checked-children="'No'"
				:checked="editform.encashable == 1"
				@change="(checked) => editform.encashable = checked ? 1 : 0"
			  />

			  <div class="invalid-feedback d-block">
				{{ errors.encashable }}
			  </div>
			</div>
			
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Gender <span class="text-danger">*</span></label
              >
			  <Field
                    name="gender_restriction"
                    as="select"
                    class="form-control"
					v-model="editform.gender_restriction"
					:class="{ 'is-invalid': errors.gender_restriction }"
                  >
				  <option value="">Gender</option>
				  <option value="Any">Any</option>
				  <option value="Male">Male</option>
				  <option value="Female">Female</option>
				  
				  <div class="invalid-feedback">{{ errors.gender_restriction }}</div>
                  <div class="gender_restrictionshow text-danger" id="gender_restriction"></div>
			  </Field>
			</div>
			
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Law Reference</label
              >
              <Field
                name="law_reference"
                type="text"
                class="form-control"
                v-model="editform.law_reference"
                :class="{
                  'is-invalid': errors?.law_reference ? errors.law_reference[0] : '',
                }"
              />
              <div class="invalid-feedback">
                {{ errors.law_reference }}
              </div>
              <div class="law_referenceshow text-danger" id="law_reference"></div>
            </div>
			
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Max Consecutive Days </label
              >
              <Field
                name="max_consecutive_days"
                type="text"
                class="form-control"
                v-model="editform.max_consecutive_days"
                :class="{
                  'is-invalid': errors?.max_consecutive_days ? errors.max_consecutive_days[0] : '',
                }"
              />
              <div class="invalid-feedback">
                {{ errors.max_consecutive_days }}
              </div>
              <div class="max_consecutive_daysshow text-danger" id="max_consecutive_days"></div>
            </div>
			
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Status <span class="text-danger">*</span></label
              >
			  <Field
                    name="active"
                    as="select"
                    class="form-control"
					v-model="editform.active"
					:class="{ 'is-invalid': errors.active }"
                  >
				  <option value="">Select Status</option>
				  <option value="1">Active</option>
				  <option value="0">Inactive</option>
				  <div class="invalid-feedback">{{ errors.active }}</div>
                  <div class="statusshow text-danger" id="active"></div>
			  </Field>
			</div>
			
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Save</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Leave Modal -->

  <!-- Approve Leave Modal -->
  <div class="modal custom-modal fade" id="approve_leave" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Update Leave</h3>
            <p>Are you sure want to update this leave?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-primary continue-btn" @click="updateLeave"
                  >Update</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-primary cancel-btn"
				  ref="updateleaveclose"
                  >Cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Approve Leave Modal -->

  <!-- Delete Leave Modal -->
  <div class="modal custom-modal fade" id="delete_approve" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Delete Leave Type</h3>
            <p>Are you sure want to delete this leave type?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-primary continue-btn" @click="deleteLeave"
                  >Delete</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-primary cancel-btn" ref="deleteleaveclose"
                  >Cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Leave Modal -->
</template>

<script>
import { ref } from "vue";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());

import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import moment from 'moment';


export default {
  emits: ["createLeave","updateLeave","updateLeavestatus","deleteLeave","createLeaveDates"],
  components: {
    Form,
    Field,
  },
  props: {
    form: [Array, Object],
	leavetypelist: [Array, Object],
	employeelist: [Array, Object],
	editform: [Array, Object],
	update_id: [Number,String],
	update_status: [Number,String],
	updateleavetype_id: [Number,String],
	delleave_id: [Number,String],
  },  
  data() {
    return {
	   items : [{txt: 'foo', val: 1, val2: 2},{txt: 'bar', val: 1, val2: 2},{txt: 'foo', val: 1, val2: 2}],
      checked:'',
      select2: null,
      SelectType: [
        "Select Leave Type",
        "Casual Leave 12 Days",
        "Medical Leave",
        "Loss of Pay",
      ],
	  createdfrom: currentDate,
	  createdto: currentDateOne,
      SelectLeave: ["Select Leave Type", "Casual Leave 12 Days"],
      startdate: currentDate,
      dateFormat: 'MM-dd-yyyy',
      startdateone: currentDateOne,
	  selected: 'A',
	  options: [
		  { item: 'A', name: 'Option A' },
		  { item: 'B', name: 'Option B' },
		  { item: 'D', name: 'Option C', notEnabled: true },
		  { item: { d: 1 }, name: 'Option D' }
	  ],
	  products: [],
	  test: '',
	  editobjfrom: '',
	  editobjto: '',
    };
  },
  methods: {
	formattedDate(formatdate){
		return moment(formatdate).format('MM-DD-YYYY');
	},
    onDateChange(){
	
		this.$emit("create-leavedates",this.createdfrom,this.createdto);
	},
	onDateEditChange(){
	
		this.$emit("edit-leavedates",this.editobjfrom,this.editobjto);
	},
	onSubmit(values) {
	  
	  this.$emit("create-leave",this.form);
	},
	closeDialog(){
		this.$refs.addleaveclose.click();
		this.$refs.editleaveclose.click();
		this.$refs.updateleaveclose.click();
		this.$refs.deleteleaveclose.click();
	},
	onUpdate(formval){
		
		
		this.$emit("update-leave",this.editform);
		
	},
	updateLeave(){
		
		this.$emit("update-leavestatus",this.update_id,this.updateleavetype_id,this.update_status);
	},
	deleteLeave(){
		this.$emit("delete-leave",this.delleave_id);
	},
	seteditdates(editobjfrom,editobjto){
		
		this.editobjto = editobjto;
		this.editobjfrom = editobjfrom;
	  
	}
  },
  setup() {
    const schema = Yup.object().shape({
	  code: Yup.string().required("Code is required"),
	  name: Yup.string().required("Name is required"),
	  entitlement_days: Yup.string().required("Entitlement Days are required"),
	  accrual_rule: Yup.string().required("Accrual rule is required"),
	  gender_restriction: Yup.string().required("Gender is required"),
	});
	
	const editschema = Yup.object().shape({
	  code: Yup.string().required("Code is required"),
	  name: Yup.string().required("Name is required"),
	  entitlement_days: Yup.string().required("Entitlement Days are required"),
	  accrual_rule: Yup.string().required("Accrual rule is required"),
	  gender_restriction: Yup.string().required("Gender is required"),
	});
	
	return {
      schema,
	  editschema
	};
  },
  watch: {
    createdfrom(val){
		
	
		this.onDateChange();
	},
	createdto(val){
		
		
		this.onDateChange();
	},
	editobjto(val){
		
	
		this.onDateEditChange();
	},
	editobjfrom(val){
		
		
		this.onDateEditChange();
	}
  }
};
</script>
